// Helper functions

export const hideIntercom = () => {
    if (window.Intercom) {
        Intercom('update', { "hide_default_launcher": true });
    }
};

export const showIntercom = () => {
    if (window.Intercom) {
        Intercom('update', { "hide_default_launcher": false });
    } 
};

export const getBrowserScrollbarWidth = () => {
    return window.innerWidth - document.documentElement.clientWidth;
};

export const deactivateScrollbar = (scrollbarWidth) => {
    document.documentElement.style.overflow = "hidden";
    document.querySelector('body').style.marginRight = `${scrollbarWidth}px`;
};

export const reactivateScrollbar = () => { 
    document.documentElement.style.overflow = "auto";
    document.querySelector('body').style.marginRight = `0`;
};

export const convertEmbedToRegularGoogleMapUrl=(embedUrl) =>{
    try {
        const url = new URL(embedUrl);

        if (!url.hostname.includes("google.com") || !url.pathname.includes("/maps/embed")) {
            throw new Error("Not a valid Google Maps embed URL.");
        }

        const pbParam = url.searchParams.get("pb");
        if (!pbParam) {
            throw new Error("Missing 'pb' parameter in the embed URL.");
        }

        const pbParts = pbParam.split("!");

        let lat = null;
        let lng = null;

        pbParts.forEach(part => {
            if (part.startsWith("2d")) {
                lng = part.substring(2); 
            } else if (part.startsWith("3d")) {
                lat = part.substring(2); 
            }
        });
 
        if (lat && lng) {
            return `https://www.google.com/maps/place/${lat},${lng}`;
        } else {
            throw new Error("Unable to extract location details from the embed URL.");
        }
    } catch (error) {
        console.error("Error converting embed URL:", error.message);
        return null;
    }
}

export const formatDate = ({ date, culture, customDate, customTime, hasWeekday }) => {
    let newDate = '';
    let newTime = '';
    let weekday = '';
  
    const dateObj = new Date(date);

    if (customDate) {
        newDate = customDate;
    } else {
        const datePart = dateObj.toLocaleDateString(culture, {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }).replace(/,/g, '');
        newDate = datePart;
        if (hasWeekday) {
            weekday = dateObj.toLocaleDateString(culture, { weekday: 'short' });
        }
    }

    if (customTime) {
        newTime = customTime;
    } else {
        const timePart = dateObj.toLocaleTimeString(culture, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        newTime = timePart;
    }

    return `${hasWeekday && weekday ? `${weekday}, ` : ''}${newDate}, ${newTime}`;
};

export const decodeHtmlElements = (string) => {
    if (!string || typeof string !== 'string') {
        return string || '';
    }

    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(string, "text/html");
        return doc.body.textContent || '';
    } catch (error) {
        console.warn('Failed to decode HTML elements:', error);
        return string;
    }
}
